import { gql } from "@apollo/client";

export const CREATE_REFERRAL_FORM = gql`
  mutation CreateReferralForm($data: FormInputData!) {
    createForm(data: $data) {
      id
      url
      createdBy
      orgId
      formFields
      createdAt
      updatedAt
      status
      numberOfSubmissions
    }
  }
`;
